import React from 'react';
import ReactLoading from 'react-loading';

import classes from './Loader.module.scss';

const Loader = () => {
  return (
    <div className={classes.loader}>
      <ReactLoading type={'spinningBubbles'} color="#8C85A8" />
    </div>
  );
};

export default Loader;
